
<div class="map" id="beachWatchMapDiv" #element>
	<google-map *ngIf="apiLoaded$ | async"  width="100%" height="100%" #map [options]="options" #mapComponent
		(boundsChanged)="onMapBoundsChanged()" 
		(zoomChanged)="onMapZoomChanged()"
		(idle)="onMapIdle()" 
		(mapClick)="onMapClicked($event)">
		
		<app-site-marker *ngFor="let site of beachSites" 
			[site]="site"			
			(markerClickedEvent)="onMapMarkerClicked($event)">
		</app-site-marker>		
		
		<app-current-location [mapRef]="mapSubject.asObservable()"
			(zoomToCurrentLocationEvent)="onZoomToCurrentLocationClicked($event)">
		</app-current-location>
		
	</google-map>
</div>
